import type { Selection } from "./useChatData";

/** Personal, per-conversation notes — private to whoever writes them,
 * same as the Later/saved-messages store. Stored server-side (not just
 * localStorage) so they survive a cleared cache or a different browser,
 * unlike this app's login session — see dbm_notes in appData.js. */

const LOCAL_SESSION_KEY = "dbm-local-session-token";

const NOTES_GET_URL = process.env.REACT_APP_NOTES_GET_URL || "/.netlify/functions/dbm-notes-get";
const NOTES_SAVE_URL = process.env.REACT_APP_NOTES_SAVE_URL || "/.netlify/functions/dbm-notes-save";

/** One stable id per conversation, independent of its display name. */
export function conversationIdFor(selection: Selection): string {
  return `${selection.kind}:${selection.id}`;
}

function token(): string | null {
  return localStorage.getItem(LOCAL_SESSION_KEY);
}

async function postJson<T>(url: string, body: Record<string, unknown>): Promise<T> {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.error || "Something went wrong — try again");
  return data as T;
}

export async function fetchNote(conversationId: string): Promise<string> {
  const t = token();
  if (!t) return "";
  const data = await postJson<{ content: string }>(NOTES_GET_URL, { token: t, conversationId });
  return data.content || "";
}

export async function saveNote(conversationId: string, content: string): Promise<void> {
  const t = token();
  if (!t) throw new Error("Your session expired — sign out and back in, then try again");
  await postJson(NOTES_SAVE_URL, { token: t, conversationId, content });
}
